import { LOCAL_STORAGE_AUTH_USER } from "../constants/localStorageKeys";

export type AuthUser = {
  token?: string;
  token_type?: string;
  roles?: Array<{ name: string; permissions?: string[] }>;
  office_ids?: Array<{ id: number; name: string }>;
  user_id?: number;
  team_id?: number;
  username?: string;
  email?: string;
  uid?: number | string;
};

export const getAuthUser = (): AuthUser | null => {
  const raw = localStorage.getItem(LOCAL_STORAGE_AUTH_USER);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as AuthUser;
  } catch {
    return null;
  }
};

export const setAuthUser = (user: AuthUser) => {
  localStorage.setItem(LOCAL_STORAGE_AUTH_USER, JSON.stringify(user));
};

export const clearAuthUser = () => {
  localStorage.removeItem(LOCAL_STORAGE_AUTH_USER);
};

export const getAuthToken = (): string | null => {
  const user = getAuthUser();
  return user?.token || null;
};

const decodeJwtPayload = (token: string): any | null => {
  try {
    const parts = token.split(".");
    if (parts.length < 2) return null;
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const payload = atob(base64);
    return JSON.parse(payload);
  } catch {
    return null;
  }
};

export const isTokenExpired = (): boolean => {
  const token = getAuthToken();
  if (!token) return true;
  const payload = decodeJwtPayload(token);
  if (!payload?.exp) return false;
  return payload.exp * 1000 <= Date.now();
};

export const isAuthenticated = (): boolean => {
  return Boolean(getAuthToken()) && !isTokenExpired();
};
